__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/878b8cd0649425ef92809c84461fb98d07d8f17bab8f6275e09d4476/";